import React from "react";
import InputBox from "./InputBox";
import ButtonBlue from "./ButtonBlue";
import { useEffect, useState } from "react";
import {
  signInWithEmail,
  findUserDocbyId,
} from "../../utils/firebase/Firebase.utils";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loadUser } from "../../store/userSlice";
import {
  FaEye,
  FaEyeSlash,
  FaLock,
  FaEnvelope,
  FaUserPlus,
  FaKey,
} from "react-icons/fa";
import { MdPrivacyTip } from "react-icons/md";
import PageModal from "../Dashboard/Components/PageModal";
import PrivacyPage from "./PrivacyPage";
import toast from "react-hot-toast";
import {
  requestNotificationPermission,
  saveUserToken,
} from "../../services/notificationService";
import { appName } from "../../utils/constants";
import { useCompany } from "../../context/CompanyContext";

function LoginForm() {
  const { companyData } = useCompany();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [viewMode, setViewMode] = React.useState(false);
  const [error, setError] = React.useState("");
  const [fieldErrors, setFieldErrors] = React.useState({
    email: "",
    password: "",
  });

  const handleMouseDownPassword = (e) => {
    e.preventDefault();
  };
  const [isLoading, setIsLoading] = React.useState(false);
  const [formData, setFormData] = React.useState({});
  const [isProcessing, setIsProcessing] = React.useState(false);
  const Navigate = useNavigate();
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsProcessing(true);
    setError(""); // Clear any previous errors
    setFieldErrors({ email: "", password: "" }); // Clear field errors

    const signIn = async () => {
      try {
        setIsLoading(true);
        const res = await signInWithEmail(formData.email, formData.password);
        if (res) {
          const { email, uid } = res.user;

          const {
            displayName,
            roles,
            department,
            linkedIdentifiers,
            photoUrl,
            principalUser,
          } = await findUserDocbyId(res.user.uid);

          dispatch(
            loadUser({
              email,
              displayName,
              uid,
              roles,
              department,
              linkedIdentifiers,
              photoUrl,
              principalUser,
            })
          );

          // Request notification permission and save token
          const token = await requestNotificationPermission();
          if (token) {
            await saveUserToken(uid, token);
          }

          Navigate("/dashboard?splash=true");
        }
      } catch (error) {
        console.error("Login error:", error);

        // Handle specific Firebase auth errors
        if (error.code === 400) {
          switch (error.message) {
            case "TOO_MANY_ATTEMPTS_TRY_LATER":
              const tooManyAttemptsMsg =
                "Too many login attempts. Please try again later or reset your password.";
              setError(tooManyAttemptsMsg);
              toast.error(tooManyAttemptsMsg);
              break;
            case "INVALID_LOGIN_CREDENTIALS":
              const invalidCredentialsMsg =
                "Invalid email or password. Please check your credentials.";
              setError(invalidCredentialsMsg);
              setFieldErrors({
                email: "Please verify your email",
                password: "Please verify your password",
              });
              toast.error(invalidCredentialsMsg);
              break;
            default:
              const defaultMsg =
                "Login failed. Please check your credentials and try again.";
              setError(defaultMsg);
              toast.error(defaultMsg);
          }
        } else {
          switch (error.code) {
            case "auth/too-many-requests":
              const tooManyRequestsMsg =
                "Too many login attempts. Please try again later or reset your password.";
              setError(tooManyRequestsMsg);
              toast.error(tooManyRequestsMsg);
              break;
            case "auth/wrong-password":
              const wrongPasswordMsg = "Incorrect password. Please try again.";
              setFieldErrors({ ...fieldErrors, password: wrongPasswordMsg });
              toast.error(wrongPasswordMsg);
              break;
            case "auth/user-not-found":
              const userNotFoundMsg =
                "No account found with this email. Please check your email or sign up.";
              setFieldErrors({ ...fieldErrors, email: userNotFoundMsg });
              toast.error(userNotFoundMsg);
              break;
            case "auth/invalid-email":
              const invalidEmailMsg =
                "Invalid email address. Please enter a valid email.";
              setFieldErrors({ ...fieldErrors, email: invalidEmailMsg });
              toast.error(invalidEmailMsg);
              break;
            case "auth/user-disabled":
              const userDisabledMsg =
                "This account has been disabled. Please contact support.";
              setError(userDisabledMsg);
              toast.error(userDisabledMsg);
              break;
            case "auth/network-request-failed":
              const networkErrorMsg =
                "Network error. Please check your internet connection and try again.";
              setError(networkErrorMsg);
              toast.error(networkErrorMsg);
              break;
            default:
              const defaultErrorMsg =
                "Login failed. Please check your credentials and try again.";
              setError(defaultErrorMsg);
              toast.error(defaultErrorMsg);
          }
        }
      } finally {
        setIsLoading(false);
        setIsProcessing(false);
      }
    };
    signIn();
  };

  const handleClickShowPassword = () => {
    setShowPassword((show) => !show);
  };

  const handleViewPrivacyPolicy = () => {
    setViewMode(!viewMode);
  };

  console.log(companyData);

  return (
    <div className="bg-white rounded-2xl shadow-xl p-8 w-[400px] border border-gray-100">
      <div className="flex flex-col items-center gap-6">
        <div className="flex flex-col items-center gap-4">
          {companyData?.companyLogo && (
            <img src={companyData.companyLogo} alt="" className="h-24" />
          )}
          <div className="title-header">{appName}</div>
          <div className="text-[#363062] text-lg font-semibold">
            Welcome Back
          </div>
          <div className="text-gray-500 text-sm text-center">
            Enter your credentials to access your account
          </div>
        </div>

        <div className="w-full">
          <form className="w-full space-y-4" onSubmit={handleSubmit}>
            <div className="relative">
              <div className="absolute top-10 left-0 pl-3 flex items-center pointer-events-none">
                <FaEnvelope className="text-[#8FCD00] h-5 w-5" />
              </div>
              <InputBox
                label="Email Address"
                type="email"
                placeholder="Enter your email address"
                onChange={handleChange}
                name="email"
                className="pl-10"
              />
            </div>

            <div className="relative">
              <div className="absolute top-10 left-0 pl-3 flex items-center pointer-events-none">
                <FaLock className="text-[#8FCD00] h-5 w-5" />
              </div>
              <InputBox
                label="Password"
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                onChange={handleChange}
                name="password"
                className="pl-10"
              />
              <button
                type="button"
                className="absolute top-10 right-2 flex items-center text-gray-400 hover:text-[#363062]"
                onClick={handleClickShowPassword}
              >
                {showPassword ? (
                  <FaEyeSlash className="h-5 w-5" />
                ) : (
                  <FaEye className="h-5 w-5" />
                )}
              </button>
            </div>

            <div className="flex  items-center justify-center">
              <Link
                to="/resetpassword"
                className="text-[#8FCD00] text-sm hover:text-[#363062] flex items-center gap-1"
              >
                <FaKey className="h-3 w-3" />
                Forgot Password?
              </Link>
            </div>

            <button
              type="submit"
              className={`w-full py-3 px-4 rounded-lg text-white font-medium transition-colors ${
                isProcessing
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#363062] hover:bg-[#2a2450]"
              }`}
              disabled={isProcessing}
            >
              {isProcessing ? "Logging in..." : "Sign In"}
            </button>

            <div className="text-center text-sm text-gray-600">
              Don't have an account?{" "}
              <Link
                to="/signup"
                className="text-[#8FCD00] hover:text-[#363062] font-medium flex items-center justify-center gap-1"
              >
                <FaUserPlus className="h-3 w-3" />
                Sign up
              </Link>
            </div>

            <div
              className="text-center text-sm text-gray-600 cursor-pointer hover:text-[#363062] flex items-center justify-center gap-1"
              onClick={handleViewPrivacyPolicy}
            >
              <MdPrivacyTip className="h-4 w-4" />
              Privacy Policy and Information
            </div>
          </form>

          {viewMode && (
            <PageModal>
              <PrivacyPage setViewMode={setViewMode} />
            </PageModal>
          )}
        </div>
      </div>
    </div>
  );
}

export default LoginForm;
